__turbopack_context__.v({
  "buySection": "WrmJAW_buySection",
  "heightOpacityIn": "WrmJAW_heightOpacityIn",
  "ringHeader": "WrmJAW_ringHeader",
  "root": "WrmJAW_root",
  "section": "WrmJAW_section",
  "sizeInfoModal": "WrmJAW_sizeInfoModal",
  "stickyPanel": "WrmJAW_stickyPanel",
});
